import { useEffect } from "react";
import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import OurLocations from "./sections/OurLocations";
import ReadyToStart from "./sections/ReadyToStart";
import Footer from "@/reusable_sections/Footer";
import MissionVision from "./sections/MissionVision";
export default function ContactPage() {
  return <div>
      
      <Header />
      <GetInTouch />
      <OurLocations />
      
      <Footer />
    </div>;
}